import React from 'react';
import { motion } from 'framer-motion';
export function OpeningHook() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-navy-900 relative" data-id="element-127" data-mp="1ux3twe3h9r5u">
      <div className="max-w-3xl mx-auto" data-id="element-128" data-mp="1uv9fzjqmizb9">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="border-l-4 border-gold-500 pl-6 sm:pl-10 py-2" data-id="element-129" data-mp="1gycix0jwwllx">
          <p className="text-2xl sm:text-3xl font-serif text-white mb-8 leading-relaxed" data-id="element-130" data-mp="xamyjeeb1nmq">
            Déjame adivinar.
          </p>

          <div className="space-y-6 text-lg sm:text-xl text-slate-300 font-light leading-relaxed" data-id="element-131" data-mp="128y77lsv5s3d">
            <p data-id="element-132" data-mp="o9p0rdugmccl">
              Ya compraste un curso. Viste horas de YouTube. Quizás incluso
              pagaste por una mentoría.
            </p>
            <p className="font-medium text-white" data-id="element-133" data-mp="3bpxvlhp6fg0o">Y aún así... nada.</p>
            <p data-id="element-134" data-mp="37ovwr1z695z8">
              Tu enlace de afiliado sigue sin clics. Tu lista de correos
              responde con silencio. Tus publicaciones tienen likes, pero cero
              ventas.
            </p>
            <p data-id="element-135" data-mp="3gpk9ltctx0aj">
              Y lo más frustrante no es el dinero que no entra — es esa voz en
              tu cabeza que ya empieza a susurrar:{' '}
              <span className="italic text-slate-400" data-id="element-136" data-mp="2t0iy1x8p9911">
                «¿Y si esto no es para mí?»
              </span>
            </p>
            <p className="pt-6 border-t border-white/10" data-id="element-137" data-mp="2nz1z479rzwn3">
              Pero antes de que cierres esta página y vuelvas a buscar otro
              curso, necesitas escuchar algo:
            </p>
            <p className="text-2xl font-serif text-gold-400 font-medium" data-id="element-138" data-mp="2xx9dcicok0le">
              El problema no eres tú. Es que nadie te ha dado el sistema
              completo.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}